import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Composants graphiques utilises

// Module metier utilises
import { EntrepriseModule } from '../../entreprises/entreprises.module';
import { ParcModule } from '../../structure/parc/parc.module';
import { DocumentSecuriteModule } from '../../document-securite/document-securite.module';
import { TypeHabilitationModule } from '../../habilitations/type-habilitation/type-habilitation.module';
import { TypeQualificationModule } from '../../habilitations/type-qualification/type-qualification.module';

// Modules Material utilises
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// Autres modules externes utilises 

// Modules communs utilises
import { BootstrapPopupModule } from '../../../shared/bootstrap-popup/bootstrap-popup.module';
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';
import { JSR310LocalDatesModule } from '../../../shared/jsr310-localdates/jsr310-localdates.module';
import { MatPaginatorIntlFr } from '../../../shared/pagination/paginator-intl-fr';
import { PannelModule } from '../../../shared/pannel/pannel.module';
import { SuggestableInputModule } from '../../../shared/suggestable-input/suggestable-input.module';

// Composants metiers
import { EditIntervenantComponent } from './components/edit-intervenant.component';
import { GestionIntervenantsComponent } from './components/gestion-intervenants.component';
import { IntervenantsFiltersComponent } from './components/intervenants-filters.component';
import { IntervenantsTableComponent } from './components/intervenants-table.component';
import { IntervenantStatusComponent } from './components/intervenant-status.component';

// Services metier
import { IntervenantService } from './services/intervenant.service';

// Pipes


@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,

		MatPaginatorModule,
		MatProgressBarModule,
		MatSortModule,
		MatTableModule,

		BootstrapPopupModule,
		CheckboxListModule,
		FilterableSelectModule,
		JSR310LocalDatesModule,
		PannelModule,
		SuggestableInputModule,

		EntrepriseModule,
		ParcModule,
		DocumentSecuriteModule,
		TypeHabilitationModule,
		TypeQualificationModule,
	],
	providers: [
		IntervenantService,
		{
			// Configuration pour que les paginators affichent des libelles en francais
			provide: MatPaginatorIntl,
			useClass: MatPaginatorIntlFr
		},
	],
	declarations: [
		EditIntervenantComponent,
		GestionIntervenantsComponent,
		IntervenantsFiltersComponent,
		IntervenantsTableComponent,
		IntervenantStatusComponent,
	],
	exports: [
		GestionIntervenantsComponent,
		IntervenantStatusComponent,
	]
})
export class IntervenantModule {
	constructor() { }
}